import styled from 'styled-components'

import { Separator } from '@blade/ui-kit'

import { AmountInputBase } from './amount-input-base'

import type { AmountInputBaseProps } from './amount-input-base'

type Props = {
  endContent?: React.ReactNode
  startContent?: React.ReactNode
  placeholder?: string
} & AmountInputBaseProps

/**
 * @deprecated Use Input numeric={true} instead
 */
export const AmountInput: React.FC<Props> = ({
  endContent,
  value,
  startContent,
  placeholder = '0',
  onChange,
  ...props
}) => (
  <Root>
    {startContent ? (
      <>
        <StartContent>{startContent}</StartContent>
        <StartSeparator>
          <Separator vertical />
        </StartSeparator>
      </>
    ) : undefined}
    <InputBase
      type="text"
      placeholder={placeholder}
      value={value}
      decimalScale={2}
      onChange={onChange}
      {...props}
    />
    {endContent ? <EndContent>{endContent}</EndContent> : undefined}
  </Root>
)

const Root = styled.div`
  display: flex;
  flex-wrap: nowrap;

  border-radius: 10px;
  background: var(--appearanceA-7);
  height: 40px;
  padding: 5px 13px 5px 15px;
  border: 1px solid transparent;

  align-items: center;
  transition: border-color 0.3s ease-in-out;

  &:focus-within {
    border-color: var(--backgroundA-5);
  }
`

const InputBase = styled(AmountInputBase)`
  background: transparent;
  color: var(--text-12);

  border: none;
  outline: none;
  height: 100%;
  width: 100%;

  font-size: 12px;
  font-weight: 600;
  line-height: 20px;

  &:disabled {
    color: var(--textA-8);
  }

  &::placeholder {
    color: var(--textA-8);
    font-weight: 400;
    line-height: 20px;
  }
`
const StartSeparator = styled.div`
  height: 100%;
  margin-inline: 15px;
`
const StartContent = styled.div`
  color: var(--text-8);

  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  justify-self: end;
  display: grid;
`
const EndContent = styled.div`
  color: var(--text-8);

  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  justify-self: end;
  display: grid;
`
